<template>
  <w-setting-sliding-popup v-loading="isLoading" ref="slidingPopup" title="시설장비 수동 등록" width="500px">
    <div slot="content">
      <div class="title-bar title-h4">기본 정보</div>
      <el-form ref="formDataRef" :rules="formDataRules" :model="formData">
        <el-row class="mr-b25 " :gutter="10">
          <el-col :span="12">
            <el-form-item label="센서명" prop="objName">
              <el-input placeholder="센서명을 입력해주세요" ref="objName" v-model="formData.objName" style="display:block;" controls-position="right"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="센서 종류">
              <el-select @change="changeIpSelect" style="width:100%" v-model="formData.objtypeId">
                <el-option v-for="item in sensorTypeList" :key="item.objtypeId" :label="item.objtypeName" :value="item.objtypeId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="title-bar title-h4">수집 장비 설정</div>
        <el-row>
          <el-form-item label="수집 장비 종류">
            <el-select style="width: 100%" @change="onChangeParentObjType" v-model="formData.parentObjtypeId">
              <el-option label="자체수집" value="FACILITY"></el-option>
              <el-option label="RTU" value="RTU"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <!-- RTU -->
      <el-row v-show="!parentObjTypeFlag">
        <el-form :model="formDataRtu" ref="formDataRtuRef" :rules="formDataRtuRules">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item prop="parentObjId" label="수집 장비">
                <el-select style="width:100%" v-model="formDataRtu.parentObjId">
                  <el-option v-for="item in rtuList" :key="item.objId" :label="item.objName" :value="item.objId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="alivecheckTcpPort" label="TCP 포트">
                <el-input placeholder="TCP 포트를 입력해주세요" v-model="formDataRtu.alivecheckTcpPort" style="display:block;" controls-position="right"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-row>
      <el-row v-show="parentObjTypeFlag">
        <el-form :rules="formDataFacilityRules" ref="formDataFacilityRef" :model="formDataFacility">
          <el-row :gutter="10" class="rtu-update-title">
            <el-col :span="12">
              <el-form-item label="IP타입">
                <el-select style="width:100%" @change="changeIpSelect" v-model="formDataFacility.ipaddressApplytype">
                  <el-option v-for="item in iptypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="ipaddress" label="IP주소">
                <el-input ref="ipfield" v-model="formDataFacility.ipaddress" style="display:block;" controls-position="right"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="SNMP 버전">
                <el-select style="width:100%" @change="onChangeSnmpVersion" v-model="formDataFacility.snmpVersion">
                  <el-option v-for="item in snmpVersionList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="snmpPort" label="SNMP 포트">
                <el-input placeholder="포트를 입력해주세요" v-model="formDataFacility.snmpPort"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-show="formDataFacility.snmpVersion != 'NONE' && formDataFacility.snmpVersion != 'V3'">
            <el-col :span="12">
              <el-form-item label="커뮤니티 값" prop="snmpCommunityRead">
                <el-input type="password" v-model="formDataFacility.snmpCommunityRead" placeholder="입력해 주세요."></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
        </el-form>
        <el-form ref="formDataV3" :model="formDataV3">
          <el-row v-show="snmpV3Flag">
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item prop="snmpV3Username" label="USER">
                  <el-input placeholder="USER명을 입력해주세요" v-model="formDataV3.snmpV3Username"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="snmpV3ContextName" label="Context 명">
                  <el-input placeholder="Context명을 입력해주세요" v-model="formDataV3.snmpV3ContextName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Context ID" prop="snmpV3ContextId">
                  <el-input v-model="formDataV3.snmpV3ContextId" placeholder="입력해 주세요."></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <span>Auth</span>
              </el-col>
              <el-col :span="12">
                <el-row type="flex" justify="end">
                  <el-switch v-model="formDataV3.authActiveFlag" :active-value="1" :inactive-value="0"></el-switch>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="10" v-show="formDataV3.authActiveFlag == '1'">
              <el-col :span="12">
                <el-form-item label="프로토콜">
                  <el-select style="width:100%" v-model="formDataV3.snmpV3AuthProtocol">
                    <el-option v-for="item in snmpAuthList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="snmpV3AuthPassword" label="비밀번호">
                  <el-input type="password" placeholder="비밀번호를 입력해주세요" v-model="formDataV3.snmpV3AuthPassword" style="display:block;" controls-position="right"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <span>Privacy</span>
              </el-col>
              <el-col :span="12">
                <el-row type="flex" justify="end">
                  <el-switch v-model="formDataV3.privActiveFlag" :active-value="1" :inactive-value="0"></el-switch>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="10" v-show="formDataV3.privActiveFlag == '1'">
              <el-col :span="12">
                <el-form-item label="프로토콜">
                  <el-select style="width:100%" v-model="formDataV3.snmpV3PrivProtocol">
                    <el-option v-for="item in snmpPrivList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="snmpV3PrivPassword" label="비밀번호">
                  <el-input type="password" placeholder="비밀번호를 입력해주세요" v-model="formDataV3.snmpV3PrivPassword" style="display:block;" controls-position="right"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-row>
        </el-form>
      </el-row>
    </div>
    <div slot="footer">
      <el-button type="solid" size="large" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="clickCloseBtn">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import { assign, merge, cloneDeep, isUndefined } from 'lodash';
import { validateIpv4, validateIpv6 } from '@/utils/string';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';
import msgUtil from '@/utils/message';
import DeviceRegistrationFmsApi from '@/api/settings/common/device-registration-fms';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import DeviceRegistrationCommonAPI from '@/api/settings/common/device-registration-common';

export default {
  name: 'WFacilityDeviceAddPopup',
  props: {
    snmpVersionList: Array,
    rtuList: Array,
  },
  data() {
    return {
      isLoading: false,
      formDataRules: {
        objName: {
          required: true,
          trigger: 'blur',
          message: '값을 입력해주세요',
        },
      },
      formDataFacilityRules: {
        ipaddress: {
          required: true,
          trigger: 'blur',
          validator: this.validatePassForIp,
        },
        snmpPort: {
          required: true,
          trigger: 'blur',
          message: '값을 입력해주세요',
        },
      },
      formDataRtuRules: {
        parentObjId: {
          required: true,
          trigger: 'blur',
          message: '값을 선택해주세요',
        },
        alivecheckTcpPort: {
          required: true,
          trigger: 'blur',
          message: '값을 입력해주세요',
        },
      },
      parentObjTypeFlag: true, // 수집장비 종류 선택 플래그 - true: 자체장비 / false: RTU장비
      snmpV3Flag: false, // snmpVersion 선택 플래그
      privProtocolFlag: false,
      validateCount: 0,
      iptypeList: [],
      snmpAuthList: [],
      snmpPrivList: [],
      formData: {
        objName: '',
        objtypeId: 'FUPS', // 센서에 대한 objtypeId
        parentObjtypeId: 'FACILITY',
      },
      formDataFacility: {
        ipaddressApplytype: 'IPv4',
        ipaddress: '',
        snmpPort: '161',
        snmpVersion: 'V1/V2',
        snmpCommunityRead: '',
      },
      formDataRtu: {
        parentObjId: '',
        alivecheckTcpPort: '22',
      },
      formDataV3: {
        authActiveFlag: '0',
        privActiveFlag: '0',
        snmpV3AuthProtocol: 'MD5',
        snmpV3AuthPassword: '',
        snmpV3ContextName: '',
        snmpV3PrivProtocol: 'DES',
        snmpV3PrivPassword: '',
        snmpV3Username: '',
        snmpV3ContextId: '',
      },
    };
  },
  computed: {
    sensorTypeList() {
      return this.$store.state.common.availableSensorList;
    },
  },
  mounted() {
    BasicinfoSubAPI.getList('IPTYPE').then((response) => {
      this.iptypeList = cloneDeep(response.data.data);
    });
    BasicinfoSubAPI.getList('SNMPAUTH').then((response) => {
      this.snmpAuthList = cloneDeep(response.data.data);
    });
    BasicinfoSubAPI.getList('SNMPPRIV').then((response) => {
      this.snmpPrivList = cloneDeep(response.data.data);
    });
  },
  methods: {
    open() {
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.parentObjTypeFlag = true;
        this.$refs.formDataRef.resetFields();
        this.$refs.formDataFacilityRef.resetFields();
        this.formData.objtypeId = 'FUPS';
        this.formData.parentObjtypeId = 'FACILITY';
        this.formDataFacility.ipaddressApplytype = 'IPv4';
        this.formDataFacility.snmpVersion = 'V1/V2';
      });
    },
    // close 버튼 클릭
    clickCloseBtn() {
      this.$refs.slidingPopup.close();
    },
    changeIpSelect() {
      this.$refs.ipfield.focus();
    },
    // snmpVersion change 함수
    onChangeSnmpVersion(value) {
      if (value === 'V3') {
        this.snmpV3Flag = true;
      } else {
        this.snmpV3Flag = false;
      }
    },
    // 수집장비 종류 select-change 함수
    onChangeParentObjType(value) {
      if (value === 'FACILITY') {
        this.parentObjTypeFlag = true;
      } else {
        this.parentObjTypeFlag = false;
      }
    },
    // 시설장비 저장 이벤트
    onSaveButton() {
      this.$refs.formDataRef
        .validate()
        .then(() => {
          const target = '시설 장비';
          const action = msgUtil.action.REGIST;
          // 자체장비, RTU form 판별 및 병합
          if (this.parentObjTypeFlag) {
            this.$refs.formDataFacilityRef
              .validate()
              .then(() => {
                // 자체장비
                merge(this.formData, this.formDataFacility);
                // snmpVersion이 V3일 경우
                if (this.snmpV3Flag) {
                  if (this.formDataV3.authActiveFlag === '0') {
                    this.formDataV3.snmpV3AuthProtocol = null;
                    this.formDataV3.snmpV3AuthPassword = null;
                  }
                  if (this.formDataV3.privActiveFlag === '0') {
                    this.formDataV3.snmpV3PrivProtocol = null;
                    this.formDataV3.snmpV3PrivPassword = null;
                  }
                  merge(this.formData, this.formDataV3);
                }
                // api 실행
                const encryptTargetData = createEncryptTargetData(this.formData, ['snmpCommunityRead', 'snmpV3AuthPassword', 'snmpV3PrivPassword']);
                getRsaEncrypt(encryptTargetData)
                  .then((encryptData) => {
                    this.isLoading = true;
                    DeviceRegistrationFmsApi.setFacilityDevice(assign(cloneDeep(this.formData), encryptData))
                      .then((response) => {
                        const result = response.data;
                        if (result.success === true) {
                          this.$message(msgUtil.getResultMsgData(action, target, true));
                          this.$emit('load-data');
                          this.clickCloseBtn();
                        } else {
                          this.$message(msgUtil.getResultMsgData(action, target, false));
                        }
                      })
                      .finally(() => {
                        this.isLoading = false;
                      });
                  })
                  .catch((e) => {
                    this.$message(msgUtil.getResultMsgData(action, target, false));
                    throw new Error(e);
                  });
              })
              .catch(() => {});
          } else {
            // RTU
            this.$refs.formDataRtuRef
              .validate()
              .then(() => {
                merge(this.formData, this.formDataRtu);
                // api 실행
                DeviceRegistrationFmsApi.setFacilityDevice(this.formData)
                  .then((response) => {
                    const result = response.data;
                    if (result.success === true) {
                      this.$message(msgUtil.getResultMsgData(action, target, true));
                      this.$emit('load-data');
                      this.clickCloseBtn();
                    } else {
                      this.$message(msgUtil.getResultMsgData(action, target, false));
                    }
                  })
                  .catch(() => {
                    this.$message(msgUtil.getResultMsgData(action, target, false));
                  });
              })
              .catch(() => {});
          }
        })
        .catch(() => {});
    },
    // IPv4, IPv6에 대한 정규식 유효성 검사
    // ES-Lint에서 정규식에 대한 코드 인식이 에러가 난다.
    validatePassForIp(rule, value, callback) {
      const params = {
        objManagetypeId: 'FMS',
        ipaddressApplytype: this.formDataFacility.ipaddressApplytype,
      };

      if (isUndefined(value) || value === '') {
        callback(new Error('값을 입력해주세요'));
      } else if (this.formDataFacility.ipaddressApplytype === 'IPv4') {
        if (validateIpv4(value)) {
          params.ipaddressIpv4 = value;
          DeviceRegistrationCommonAPI.checkIpaddressValidation(params).then((response) => {
            if (response.data.data) {
              this.formDataFacility.ipaddressIpv4 = value;
              callback();
            } else {
              callback(new Error('이미 사용 중인 IP입니다.'));
            }
          });
        } else {
          callback(new Error('올바른 IPv4 주소형식을 입력해주세요'));
        }
      } else {
        /* eslint-disable no-lonely-if */
        if (validateIpv6(value)) {
          params.ipaddressIpv6 = value;
          DeviceRegistrationCommonAPI.checkIpaddressValidation(params).then((response) => {
            if (response.data.data) {
              this.formDataFacility.ipaddressIpv6 = value;
              callback();
            } else {
              callback(new Error('이미 사용 중인 IP입니다.'));
            }
          });
        } else {
          callback(new Error('올바른 IPv6 주소형식을 입력해주세요'));
        }
        /* eslint-enable no-lonely-if */
      }
    },
  },
};
</script>
<style scoped>
.facility-add-title {
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/FacilityDevice/popup/FacilityDeviceAddPopup.vue